module.exports = __webpack_public_path__ + "img/teacher.3ab62162.svg";